module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"welcomeBack":"Velkommen tilbage","forgottenPassword":"Glemt din adgangskode?","changeCredentials":"Skift login","rememberMe":"Husk mig","notYou":"Ikke dig?"}}')
  delete Component.options._Ctor
}
